<template>
  <component
    :is="tag"
    :to="to"
    :href="href"
    :form="form"
    :class="classes"
    :append="append"
    @click="bubbleEvent"
  >
    <template v-if="text">{{ text }}</template>
    <slot v-else></slot>
  </component>
</template>

<script>
export default {
  props: {
    active: { type: Boolean, default: false },
    text: { type: String, default: null },
    to: { type: undefined, default: null },
    href: { type: undefined, default: null },
    anchor: { type: Boolean, default: false },
    form: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    flat: { type: Boolean, default: false },
    ghost: { type: Boolean, default: false },
    ribbon: { type: Boolean, default: false },
    teal: { type: Boolean, default: false },
    gold: { type: Boolean, default: false },
    green: { type: Boolean, default: false },
    red: { type: Boolean, default: false },
    delete: { type: Boolean, default: false },
    gray: { type: Boolean, default: false },
    internal: { type: Boolean, default: false },
    append: { type: Boolean, default: false }
  },

  computed: {
    tag() {
      return this.to ? 'router-link' : this.href || this.anchor ? 'a' : 'button'
    },
    classes() {
      return [
        'button',
        {
          'button--active': this.active,
          'button--simple': !this.flat,
          'button--flat': this.flat,
          'button--small': this.small,
          'button--large': this.large,
          'button--disabled': this.disabled,
          'button--bordered': this.bordered,
          'button--ghost': this.ghost,
          'button--ribbon': this.ribbon,
          'button--teal': this.teal,
          'button--gold': this.gold,
          'button--green': this.green,
          'button--red': this.red,
          'button--delete': this.delete,
          'button--gray': this.gray
        }
      ]
    }
  },

  methods: {
    focus() {
      this.$el.focus()
    },
    bubbleEvent(event) {
      this.$emit(event.type, event)
    }
  }
}
</script>

<style lang="scss">
.button {
  @include ellipsis-overflow;

  &--disabled {
    pointer-events: none;
  }
}
</style>
